<script setup lang="ts">
import merge from 'lodash-es/merge';
import type { ListItemModel as SectionListItemModel } from '#layers/prawopl/app/pages/cms/modules/wk-sections/_runtime/services/SectionsService';
import SectionsService from '#layers/prawopl/app/pages/cms/modules/wk-sections/_runtime/services/SectionsService';

defineOptions({
    name: 'WkNewsSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    limit: null,
    onlyMobile: false,
    interactiveHeader: false,
    headerLink: ''
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({})
    }));
}

async function fetchSection(id: number): Promise<SectionListItemModel>
{
    const response = await SectionsService.fetchAutocomplete(id);

    return response || null;
}

async function searchSection(query: string, limit: number): Promise<SectionListItemModel[]>
{
    return await SectionsService.getAutocomplete(query, limit);
}
onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <div>
        <IdeoFormGroup :label="$t('[[[Liczba wyświetlanych aktualności]]]')">
            <IdeoFormInput
                v-model="form.settings.limit"
                type="number"
                :default-value="6"
                :placeholder="$t('[[[Wprowadź limit aktualności]]]')"
            />
        </IdeoFormGroup>

        <IdeoFormGroup>
            <IdeoFormCheckbox v-model="form.settings.onlyMobile" name="onlyMobile">
                {{ $t('[[[Tylko na urządzeniach mobilnych]]]') }}
            </IdeoFormCheckbox>
        </IdeoFormGroup>

        <IdeoFormGroup>
            <IdeoFormCheckbox v-model="form.settings.interactiveHeader" name="interactiveHeader">
                {{ $t('[[[Interaktywny nagłówek]]]') }}
            </IdeoFormCheckbox>
        </IdeoFormGroup>

        <IdeoFormGroup>
            <IdeoFormInput
                v-model="form.settings.headerLink"
                :label="$t('[[[Link do nagłówka]]]')"
                :placeholder="$t('[[[Wprowadź URL]]]')"
            />
        </IdeoFormGroup>

        <IdeoFormGroup :label="$t('[[[Wybierz sekcje]]]')">
            <IdeoAutocomplete
                v-model="form.settings.sectionId"
                name="sectionId"
                track-by="id"
                :placeholder="$t('[[[Brak sekcji]]]')"
                :default-label="$t('[[[Brak sekcji]]]')"
                :fetch="(id: number) => fetchSection(id)"
                :search="(query: string, limit: number) => searchSection(query, limit)"
            >
                <template #selected="{ option }">
                    <div class="text-wrap">
                        {{ option.name }}
                    </div>
                </template>
                <template #option="{ option }">
                    <div class="text-wrap">
                        {{ option.name }}
                    </div>
                </template>
            </IdeoAutocomplete>
        </IdeoFormGroup>
    </div>
</template>
